import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("playstation 4") != -1;
  if (comp_agent) {
    logger.info ("[PS4 detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/ps4/detection.js